import { ElMessage } from "element-plus";

export const successAlert = (msg) => {
  ElMessage({
    type: "success",
    message: msg || "Successfully",
  });
};
